export { wrapRootElement } from './src/graphql-client/graphql-client-provider'
export const onServiceWorkerUpdateReady = () => window.location.reload(true)
